<div
  class="loading-card-holder"
  [class.animations-enabled]="animationEnabled"
  [ngClass]="type"
  *ngFor="let i of [].constructor(count); let idx = index"
>
  <div class="post-type loading-card" *ngIf="type === 'post'">
    <div class="top">
      <div class="img"></div>
      <div class="content">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
      </div>
    </div>
    <div class="bottom">
      <div class="footer">
        <div class="placeholder-item"></div>
        <div class="placeholder-item"></div>
        <div class="placeholder-item"></div>
        <div class="placeholder-item"></div>
      </div>
    </div>
  </div>

  <div class="post-type gallery-loading-card" *ngIf="type === 'post-gallery'">
    <div class="top">
      <div class="img"></div>
    </div>
    <div class="bottom">
      <div class="content">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
      </div>
      <div class="footer">
        <div class="placeholder-item"></div>
        <div class="placeholder-item"></div>
        <div class="placeholder-item"></div>
        <div class="placeholder-item"></div>
      </div>
    </div>
  </div>

  <div class="widget-loading-card" *ngIf="type === 'widget'">
    <div class="tools">
      <div class="check"></div>
      <div class="title"></div>
      <div class="actions">
        <div class="action"></div>
        <div class="action"></div>
        <div class="action"></div>
        <div class="action"></div>
        <div class="action"></div>
        <div class="action"></div>
      </div>
    </div>
    <div class="content"></div>
  </div>
</div>
